import AppUserIndex from "./users.vue";
import AppUserList from "./user-list/user-list.vue";
import AppUserItem from "./user-item/user-item.vue";

const userRoutes = [
  {
    path: "users",
    component: AppUserIndex,
    meta: {
      auth: {
        roles: "user.index",
        redirect: { name: "auth.login" },
        forbiddenRedirect: { to: "/403" }
      }
    },
    children: [
      {
        path: "",
        name: "user.index",
        component: AppUserList,
        meta: {
          auth: {
            roles: "user.index",
            redirect: { name: "auth.login" }
          }
        }
      },
      {
        path: "create",
        name: "user.create",
        component: AppUserItem,
        meta: {
          auth: {
            roles: "user.create",
            redirect: { name: "user.index" }
          }
        }
      },
      {
        path: ":id",
        name: "user.edit",
        component: AppUserItem,
        meta: {
          auth: {
            roles: ["user.updateOwn", "user.update"]
          }
        }
      }
    ]
  }
];

export default userRoutes;
